import React from 'react';
import { Card, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./style/style.css"

function SearchCard({ api }) {
  const navigate = useNavigate();

  const changeRoute = () => {
    navigate(api.path)
  }
  return (
    <Card className="shadow search_card" onClick={changeRoute} style={api.id === 0 ? {display: "none"} : {display: "block"}}>
      <div className="search_card_body">
        <Col className="search_card_col">
          <img src={api.logo} style={{}} alt="desc" />
        </Col>
        <Col xs={10}>
          <h3>{api.name}</h3>
          {api.desc}
        </Col>
      </div>
    </Card>
  );
}

export default SearchCard;